export default __webpack_public_path__ + "static/media/billing-background-card.3d7d8701.png";